import { render, staticRenderFns } from "./EditAllergenItem.vue?vue&type=template&id=e17c06c0&scoped=true"
import script from "./EditAllergenItem.vue?vue&type=script&lang=ts"
export * from "./EditAllergenItem.vue?vue&type=script&lang=ts"
import style0 from "./EditAllergenItem.vue?vue&type=style&index=0&id=e17c06c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17c06c0",
  null
  
)

export default component.exports